export interface IForm {
    VariavelNo: number;
    ValorTexto?: string;
    ValorDado?: string;
    ValorData?: string;
    Alterado?: boolean;
}
